<template>
  <div>
    <ul>
      <li v-for="(pkg, index) in deDupedItems" :key="index" flat class="">
        {{ pkg.description }}
        <span v-if="pkg.sample=='1'" class="caption"> (sample)</span>
        <span v-if="pkg.active=='0'" class="caption"> (inactive)</span>
        <span v-if="pkg.discontinued =='1'" class="caption"> (discontinued)</span>
        <input type="hidden" data-field="package_ndc" :value="pkg.package_ndc "/>

      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PackageList",
  props: {
    packagingArr: null
  },
  data: function() {
    return {};
  },
  methods: {
    // removes the packlage ndc from the string and removes words like "plastic"
      cleanString(str) {
          str = str.replace(/\(?[0-9-]{10,14}\)?/gim, " "); // remove NDCs
    //       str = str.replace(/1 BOTTLE.*1 CARTON.*>/gim, " "); 
    //       str = str.replace(/(\d) BOTTLE.*1 CARTON.*>/gim, "$1 bottles,"); 
       str =  str.replace(/bottle,\s?PLASTIC/gim, "bottle "); // remove plastic
    //    str =  str.replace(/,\s?DROPPER/gim, " "); // remove dropper
    //    str =  str.replace(/in 1 carton\s*>/gim, ", ");
    str =  str.replace(/>/gim, ": ");

          return  str.toLowerCase().trim();
      }
  },
  computed: {
    // this takes the package list array, cleans the description string, and eliminates any duplicate results
    // without this there were rows that had a different product package NDC but the exact same text, eg)
    // 1 BOTTLE, DROPPER in 1 CARTON (24208-537-75) > 7.5 mL in 1 BOTTLE, DROPPER
    // 1 BOTTLE, DROPPER in 1 CARTON (24208-537-25) > 7.5 mL in 1 BOTTLE, DROPPER
      deDupedItems: function() {
      let rtn = [];
      let temp = [];
      let cleanString = this.cleanString;
      // there's gotta be a better way . . .
      this.packagingArr.forEach(function(row) {        
        let tempIndex = "";
        row.description = cleanString(row.description);
        tempIndex +=  row.description;
        tempIndex += "|" + (row.sample ? row.sample : "b");
        tempIndex += "|" +  (row.active ? row.active : "c");
        tempIndex += "|" + (row.discontinued ? row.discontinued : "d");
        if (temp.indexOf(tempIndex) === -1) {
          rtn.push(row);
          temp.push(tempIndex);
        }
      });

      return rtn;
    },
  },
};
</script>